import React, { useEffect, useMemo, useState } from 'react';
import api from '../api';

export default function MaterialManagement() {
  const [rows, setRows] = useState([]);
  const [sectionsModal, setSectionsModal] = useState(null); // { crsmatno, chapter, sections }
  const [loadingSections, setLoadingSections] = useState(false);

  useEffect(() => {
    api.get('/admin/materials').then((res) => setRows(res.data));
  }, []);

  // 같은 과목(subject)이 연속되는 구간의 시작 행에만 rowSpan을 부여해 병합된 것처럼 보이게 한다.
  const subjectSpans = useMemo(() => {
    const spans = {};
    rows.forEach((r, i) => {
      if (i === 0 || rows[i - 1].subject !== r.subject) {
        let span = 1;
        while (i + span < rows.length && rows[i + span].subject === r.subject) span += 1;
        spans[i] = span;
      }
    });
    return spans;
  }, [rows]);

  const openSections = async (r) => {
    setLoadingSections(true);
    setSectionsModal({ crsmatno: r.crsmatno, chapter: r.chapter, sections: [] });
    const res = await api.get(`/materials/${r.crsmatno}/sections`);
    setSectionsModal({ crsmatno: r.crsmatno, chapter: r.chapter, sections: res.data });
    setLoadingSections(false);
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>항공정비사 표준교재 (2024)</h2>
      </div>

      <div className="card">
        <div className="table-scroll">
          <table className="data-table subject-curriculum-table">
            <thead>
              <tr>
                <th>순번</th>
                <th>과목</th>
                <th>단원(챕터)</th>
                <th>섹션</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.crsmatno}>
                  <td>{i + 1}</td>
                  {subjectSpans[i] && (
                    <td rowSpan={subjectSpans[i]} className="subject-curriculum-subject-cell">
                      {r.subject}
                    </td>
                  )}
                  <td className="subject-curriculum-chapter">{r.chapter}</td>
                  <td>
                    <button className="btn-link" type="button" onClick={() => openSections(r)}>섹션보기</button>
                  </td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr>
                  <td colSpan="4" className="empty-row">등록된 표준교재가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {sectionsModal && (
        <div className="modal-overlay" onClick={() => setSectionsModal(null)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{sectionsModal.crsmatno} - {sectionsModal.chapter}</h3>
              <button className="btn-ghost" type="button" onClick={() => setSectionsModal(null)}>닫기</button>
            </div>
            <div className="table-scroll">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>섹션코드</th>
                    <th>섹션명</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingSections && (
                    <tr><td colSpan="2" className="empty-row">불러오는 중...</td></tr>
                  )}
                  {!loadingSections && sectionsModal.sections.map((s) => (
                    <tr key={s.crssectno}>
                      <td>{s.crssectno}</td>
                      <td>{s.sections}</td>
                    </tr>
                  ))}
                  {!loadingSections && sectionsModal.sections.length === 0 && (
                    <tr><td colSpan="2" className="empty-row">등록된 섹션이 없습니다.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
